import React from "react";

const stats = [
  { k: "16+", v: "Years in Business" },
  { k: "50,000+", v: "Customers Served" },
  { k: "5,000+", v: "Systems Installed" },
  { k: "15+", v: "Cities Served" },
];

export default function About() {
  return (
    <section id="about" className="border-b border-zinc-200">
      <div className="px-6 md:px-12 lg:px-24 py-24 md:py-32 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-6">
          <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#002FA7] mb-4">
            /// About Aquamatic
          </div>
          <h2 className="text-4xl sm:text-5xl font-semibold tracking-tight leading-tight">
            Engineered in India. Trusted across industries.
          </h2>
          <p className="mt-6 text-zinc-700 text-lg leading-relaxed">
            Aquamatic Inc. was founded by a team of hydraulic and electronics engineers on a
            simple premise: water is too critical to be left to switches and floats. Today,
            our controllers protect pumps, motors and reservoirs across residential towers,
            manufacturing lines, hospitals and public infrastructure — with a single
            product-line philosophy: <span className="font-medium text-zinc-900">rugged, wireless, and boringly reliable</span>.
          
          </p>

          <div className="mt-10 border border-zinc-300">
            <img
              src="https://images.unsplash.com/photo-1638734254958-4a11c989e9bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHx3YXRlciUyMHNlbnNvciUyMGNpcmN1aXQlMjBib2FyZHxlbnwwfHx8fDE3ODMyNTcwMjN8MA&ixlib=rb-4.1.0&q=85"
              alt="Wireless sensor circuit board"
              className="w-full h-64 object-cover"
            />
          </div>
        </div>

        <div className="lg:col-span-6 lg:pl-12 flex flex-col justify-between">
          <div className="grid grid-cols-2 gap-6">
            {stats.map((s) => (
              <div key={s.v} className="border-t-2 border-[#002FA7] pt-4">
                <div className="text-5xl font-bold tracking-tighter">{s.k}</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 mt-2">
                  {s.v}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 p-8 bg-[#002FA7] text-white">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/70 mb-3">
              /// Why us
            </div>
            <p className="text-lg leading-relaxed">
              16 years in the field, on-ground engineers in 15+ cities, and firmware you can
              trust in a hospital ICU or a chemical plant. That&apos;s the Aquamatic promise.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
